import { useMemo } from "react";
import { usePlatformAdmin } from "context/PlatformAdminContext";
import { resolvePlatformDashboardCapabilities } from "pages/PlatformAdmin/Dashboard/platformDashboardCapabilities.utils";

export const usePlatformPermissionsRevision = () => {
  const { permissionsRevision } = usePlatformAdmin();
  return permissionsRevision ?? 0;
};

export const usePlatformDashboardCapabilities = () => {
  const revision = usePlatformPermissionsRevision();

  return useMemo(() => resolvePlatformDashboardCapabilities(), [revision]);
};
